import { render, staticRenderFns } from "./Pneu.vue?vue&type=template&id=4f167e92&scoped=true&"
import script from "./Pneu.vue?vue&type=script&lang=ts&"
export * from "./Pneu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f167e92",
  null
  
)

export default component.exports